import { Filters } from 'layouts/Dashboard/subcomponents/Notifications/constant';
import { Observable } from 'rxjs';
import GenericService from 'services/genericService';
import { Alerts, Notification } from 'utils/api/models/alertsAndNotifications/alertsAndNotifications';
import { getNotificationsRest, readAllNotifications, readNotification } from 'utils/api/queries/omantelMicroApi';
import { getAlerts } from 'utils/api/queries/wcm';

export class AlertsAndNotificationsService extends GenericService {
	public static getAlerts(): Observable<Alerts> {
		return getAlerts()
			.withErrorHandling()
			.disableCache()
			.call();
	}

	public static getNotifications(limit: number): Observable<any> {
		return getNotificationsRest(limit)
			.disableCache()
			.call();
	}
	public static readAllNotifications(): Observable<any> {
		return readAllNotifications()
			.disableCache()
			.call();
	}
	public static readNotification(notificationId: string): Observable<any> {
		return readNotification(notificationId).call();
	}

	// Function to map and filter notifications by language
	public static getNotificationsByLanguage(data: any, language: string): Notification[] {
		return data.flatMap((item: any) =>
			item.content
				.filter((content: any) => content.language === language)
				.map((content: any) => ({
					notificationId: item.notificationId.toString(),
					notificationType: item.notificationType,
					notificationSubType: item.notificationSubType,
					status: item.status === Filters.Unread ? Filters.Unread : Filters.Read,
					title: content.title,
					message: content.message,
					createdAt: item.createdAt,
					parameters: item.parameters,
				}))
		);
	}
}
